import { createFileRoute } from '@tanstack/react-router';
import { ItemLayout } from '../../layouts/ItemSelection/itemLayout';

export const Route = createFileRoute('/$retailer/item-selection')({
  component: ItemLayout,
});
